import { ActionTree } from 'vuex';
import axios, { AxiosResponse } from 'axios';
import { ProfileState, User } from './types';
import { RootState } from '@/vuex/types';
import { state } from '@/modules/configuration/store';

function parseJwt(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join(''),
    );

    return JSON.parse(jsonPayload);
}

export const actions: ActionTree<ProfileState, RootState> = {
    fetchData({ commit }): void {
        axios({
            url: 'https://....',
        }).then(
            response => {
                const payload: User = response && response.data;
                commit('profileLoaded', payload);
            },
            error => {
                console.log(error);
                commit('profileError');
            },
        );
    },
    login({ commit }, credentials) {
        return axios
            .post(state.environment.apiUrl + 'oauth/token', credentials, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
            .then((response: AxiosResponse) => {
                commit('storeToken', response.data.access_token);
                const userData = parseJwt(response.data.access_token);
                const user: User = {
                    login: userData.unique_name[0],
                    firstName: userData.unique_name[1],
                    lastName: userData.family_name,
                };
                commit('profileLoaded', user);
            });
    },
    logout({ commit }) {
        commit('clearUserData');
    },
    register({ commit }, model) {
        const data = `FirstName=${model.FirstName}&LastName=${model.LastName}&Email=${model.Email}&Password=${model.Password}&ConfirmPassword=${model.ConfirmPassword}&Username=${model.Username}`;
        return axios
            .post(state.environment.apiUrl + 'api/accounts/create', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
            .then(response => {
                const userData = response.data;
                const user: User = {
                    login: userData.UserName,
                    firstName: userData.FirstName,
                    lastName: userData.LastName,
                    email: userData.Email,
                    emailConfirmed: userData.EmailConfirmed,
                };
                commit('profileLoaded', user);
            });
    },
};
